import {getToken} from "../utilities/useToken"

export const checkUserAdminAccess = async () => {
    const {role, is_admin} = getToken(true) || {}
    // is_admin is not a boolean
    if (is_admin === "true" || role === "Administrator") {
        return {readOnly: false}
    }

    return {readOnly: true}
}
